import React from 'react'

import Title from 'components/base/Title'
import Content, { Theme as ContentTheme } from 'components/base/Content'
import Paragraph from 'components/base/Paragraph'
import LocationIcon, { Theme as LocationIconTheme } from 'components/base/Icon/LocationIcon'
import StartQuoteButton from 'components/base/StartQuoteButton'
import ButtonRow from 'components/base/Button/Row'

import { Props } from './types'

const CtaQuote: React.FC<Props> = ({
  theme,
  trackingInfo,
}): React.ReactElement => (
  <Content theme={ContentTheme.yellow} center={true}>
    <Title level={2}>Got a Minute?</Title>
    <LocationIcon theme={LocationIconTheme.watch} />
    <Content short={true} center={true}>
      <Paragraph theme={theme}>
        Get an awesome price on a great plan in minutes.
      </Paragraph>
      <Paragraph theme={theme}>
        We’ll provide recommendations based on your situation and find you
        the best price. Do it on your own, or with the help of a live
        Insurance Concierge<sup>®</sup>.
      </Paragraph>
    </Content>
    <ButtonRow>
      <StartQuoteButton trackingInfo={trackingInfo} />
    </ButtonRow>
  </Content>
)

export default CtaQuote

export * from './types'
